/**
 * Utilidades para interactuar con la API de Mercado Pago
 * Usa un servidor proxy local para evitar problemas de CORS
 */

import { supabase } from '../config/supabase';

/**
 * Consulta el estado de un pago en Mercado Pago a través del servidor proxy local
 * @param {string} paymentId - ID del pago en Mercado Pago
 * @returns {Promise<{success: boolean, status?: string, nuevoEstado?: string, data?: any, message: string}>}
 */
export const consultarEstadoPago = async (paymentId) => {
  try {
    console.log(`🔍 Consultando estado de pago en Mercado Pago: ${paymentId}`);
    
    if (!paymentId) {
      return {
        success: false,
        message: 'No se proporcionó payment_id'
      };
    }
    
    // Usar servidor proxy local en lugar de Edge Function
    const response = await fetch('http://localhost:3001/api/verificar-pago', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ paymentId })
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('❌ Error en servidor proxy:', errorData);
      return {
        success: false,
        message: errorData.message || 'Error en servidor proxy'
      };
    }

    const data = await response.json();
    console.log('✅ Respuesta del servidor proxy:', data);
    return data;
    
  } catch (error) {
    console.error('❌ Error invocando servidor proxy:', error);
    return {
      success: false,
      message: `Error: ${error.message}`
    };
  }
};

/**
 * Mapea estados de Mercado Pago a estados locales
 * @param {string} mpStatus - Estado de Mercado Pago
 * @returns {string} - Estado local
 */
export const mapearEstadoPago = (mpStatus) => {
  const statusMap = {
    'approved': 'aprobado',
    'rejected': 'rechazado',
    'cancelled': 'cancelado',
    'in_process': 'pendiente',
    'pending': 'pendiente'
  };
  return statusMap[mpStatus] || 'pendiente';
};
